'use strict';

module.exports = require('./Trigger');


// WEBPACK FOOTER //
// ../~/rc-trigger/lib/index.js